<template>
</template>

<script>
	export default {
		props: {
			session: String
		},
		
		created() {
			this.request({
				url: '/stationed/user/loginBySession',
				data: {
					session: this.session
				},
				success: data => {
					this.$store.commit('setSession', data.user_info.session);
					this.$store.commit('setUserInfo', data.user_info);
					this.$store.commit('setNav', data.user_menu_list || []);
					this.$store.commit('setAuth', Array.from(data.user_menu_key_list, item => item.menu_unique_key));
					this.navigateTo('/');
				},
				fail: () => {
					this.navigateTo('/login');
					return false;
				}
			});
		}
	}
</script>